import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { TuiButton, TuiLoader } from '@taiga-ui/core';

@Component({
  selector: 'app-content-loader',
  templateUrl: './content-loader.component.html',
  styleUrls: ['./content-loader.component.less'],
  imports: [TuiLoader, TranslatePipe, TuiButton],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ContentLoaderComponent {
  @Input() textEvent = 'Loading';

  @Input() isVisibleButton = true;

  @Output() cancelEvent = new EventEmitter();

  cancel() {
    this.cancelEvent.emit();
  }
}
